import { Link } from "react-router-dom"

// material-ui
import { Grid, Stack, Typography } from "@mui/material"

// importation du projet
import AuthLogin from "./auth-forms/AuthLogin"
import AuthWrapper from "./AuthWrapper"
import AuthForgetPassword from "./auth-forms/AuthForgetPassword"
import { useTranslation } from "react-i18next"

// ================================|| CONNEXION ||================================ //

const ForgetPassword = () => {
  const { t } = useTranslation()

  return (
    <AuthWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="baseline"
            sx={{ mb: { xs: -0.5, sm: 0.5 } }}
          >
            <Typography variant="h3">{t("forget-password")}</Typography>
            <Typography
              component={Link}
              to="/auth/login"
              variant="body1"
              sx={{ textDecoration: "none" }}
              color="primary"
            >
              {t("login")}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <AuthForgetPassword />
        </Grid>
      </Grid>
    </AuthWrapper>
  )
}

export default ForgetPassword
